import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const navigate = useNavigate();

  // 검색 페이지로 이동하는 핸들러
  const handleSearchClick = () => {
    navigate('/search');
  };

  // 로고 클릭 시 홈으로 이동하는 핸들러
  const handleLogoClick = () => {
    navigate('/');
  };

  // 환경에 따른 이미지 경로 설정
  const getImagePath = () => {
    const hostname = window.location.hostname;
    
    // GitHub Pages 또는 로컬 환경
    if (hostname.includes('github.io') || hostname === 'localhost' || hostname === '127.0.0.1') {
      return '/home/images/logos/logo.png';
    }
    
    // S3 배포 환경
    return '/images/logos/logo.png';
  };

  return (
    <div className="md-app-bar border-b border-gray-200 sticky top-0 z-50 bg-white">
      {/* GNB 영역 */}
      <div className="px-4 py-2 flex justify-between items-center h-[52px]">
        {/* 로고 */}
        <div className="flex items-center">
          <button
            onClick={handleLogoClick}
            className="flex items-center justify-center min-h-[44px] min-w-[44px] py-1 rounded-lg hover:bg-gray-50 active:bg-gray-100 transition-colors duration-150"
            aria-label="Go to home"
          >
            <img
              src={getImagePath()}
              alt="Korea Order"
              className="h-5 w-auto"
            />
          </button>
        </div>

        {/* 검색 아이콘 */}
        <div className="flex items-center">
          <button
            onClick={handleSearchClick}
            className="flex items-center justify-center min-h-[44px] min-w-[44px] rounded-lg hover:bg-gray-50 active:bg-gray-100 transition-colors duration-150"
            aria-label="Search restaurants and food"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-5 h-5 text-gray-700"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header; 